import { Box, FormHelperText, SxProps, Theme } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { SelectInputProps } from '@mui/material/Select/SelectInput'
import React from 'react'

type InputSelectProps = {
  label: string
  name: string
  disabled?: boolean
  options: ItemOption[]
  sx?: SxProps<Theme>
  value?: string
  onChange?: SelectInputProps<string>['onChange']
  error?: boolean
  errorText?: React.ReactNode
}

export type ItemOption = {
  value: string
  label: string
}

export const itemOptionsInit: ItemOption = {
  value: '0',
  label: 'Selecione',
}

export const InputSelect: React.FC<InputSelectProps> = ({
  label,
  name,
  disabled,
  options,
  sx,
  onChange,
  value,
  error,
  errorText,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <InputLabel>{label}</InputLabel>
      <Select
        fullWidth
        size='small'
        id={`${name}Id`}
        name={name}
        value={value || '0'}
        label={label}
        disabled={disabled}
        onChange={onChange}
        sx={sx}
        placeholder='Selecionar'
        error={error}
      >
        {!options.some((item) => item.value === itemOptionsInit.value) && (
          <MenuItem value='0'>
            <em>Selecione</em>
          </MenuItem>
        )}
        {options.map((item) => (
          <MenuItem key={item.value} value={String(item.value)}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
      {error && errorText && <FormHelperText>{errorText}</FormHelperText>}
    </Box>
  )
}
